/**
 * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
 * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
 *
 * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
 */

/*
 * Keys of highlighter actions
 */
export const actionKeys = Object.freeze({
    highlightYellow: 'yellow',
    highlightBlue: 'blue',
    highlightPink: 'pink',
    highlightGreen: 'green',
    highlightOrange: 'orange',
    eraser: 'eraser',
    clearAll: 'clearAll'
});

export const highlightBaseClassName = 'highlighter-txt';
